import { render, staticRenderFns } from "./GerarRelatorioImoveis.vue?vue&type=template&id=60660e2b&scoped=true&"
import script from "./GerarRelatorioImoveis.vue?vue&type=script&lang=js&"
export * from "./GerarRelatorioImoveis.vue?vue&type=script&lang=js&"
import style0 from "./GerarRelatorioImoveis.vue?vue&type=style&index=0&id=60660e2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60660e2b",
  null
  
)

export default component.exports